import { cloneDeep } from 'lodash';
import { DataExport } from '../data-export';

export interface ColumnConfig {
  shouldBeFullyVisible: boolean;
}

export interface TableConfig {
  shouldBeFullyVisible?: boolean;
  columnsConfig?: ColumnConfig[];
}

export class ExcelTable {
  private _colsCount: number;
  constructor(
    private table: DataExport.ExportCell[][],
    private tableConfig: TableConfig = {}
  ) {
    this._colsCount = Math.max(...this.table.map(row => row.length));
  }

  public get exportConfig() {
    return cloneDeep(this.tableConfig);
  }

  public get rowsCount() {
    return this.table.length;
  }

  public get colsCount() {
    return this._colsCount;
  }

  public getValues() {
    return this.table.map(row =>
      row.map(({ value }: DataExport.ExportCell) => value)
    );
  }

  public getFormatting(): string[][] {
    return this.table.map(row =>
      row.map(({ format }: DataExport.ExportCell) => format)
    );
  }

  public getColSpan(): number[][] {
    return this.table.map(row =>
      row.map(({ colSpan }: DataExport.ExportCell) => colSpan)
    );
  }
}
